import { ChipTypes } from '@lib/components/Chip/Chip';
import ErrorWarning from '@lib/assets/icons/error_warning.svg?react';
import { StatusKind } from '../enums';
import styles from '../Monitoring.module.scss';

export default function getStatusOptions({ t }) {
  return [
    {
      value: StatusKind.WarningAndAlert,
      label: t('warning-and-alert'),
      data: {
        color: ChipTypes.chipRed,
        leftIconComponent: <ErrorWarning />,
        // leftIconSize: 'md-24',
      },
    },
    {
      value: StatusKind.Warning,
      label: t('warning'),
      data: {
        color: ChipTypes.chipOrange,
        leftIcon: 'warning',
        leftIconClassName: styles.warningOption,
        // leftIconSize: 'md-24',
      },
    },
    {
      value: StatusKind.Alert,
      label: t('alert'),
      data: {
        color: ChipTypes.chipRed,
        leftIcon: 'error',
        leftIconClassName: styles.alertOption,
        // leftIconSize: 'md-24',
      },
    },
    {
      value: StatusKind.DeadlineMissed,
      label: t('deadline-missed'),
      data: {
        color: ChipTypes.chipCorral,
        leftIcon: 'clock_loader_20',
        leftIconSymbolsOutlined: true,
        leftIconClassName: styles.deadlineMissedOption,
        // leftIconSize: 'md-24',
      },
    },
  ];
}
